import { render, staticRenderFns } from "./billingRules.vue?vue&type=template&id=d385be78"
import script from "./billingRules.vue?vue&type=script&lang=js"
export * from "./billingRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports